import { modifyState } from '~src/state';
import { SETTINGS_KEYS, DEFAULT_SETTINGS } from './constants';

export function loadSettingsFromLocalStorage() {
  const spellCheckEnabled = localStorage.getItem(
    SETTINGS_KEYS.SPELL_CHECK_ENABLED
  );
  const alignmentLinesEnabled = localStorage.getItem(
    SETTINGS_KEYS.ALIGNMENT_LINES_ENABLED
  );
  const canvasAlignmentLinesEnabled = localStorage.getItem(
    SETTINGS_KEYS.CANVAS_ALIGNMENT_LINES_ENABLED
  );
  const objectAlignmentLinesEnabled = localStorage.getItem(
    SETTINGS_KEYS.OBJECT_ALIGNMENT_LINES_ENABLED
  );
  const showDistanceMeasurements = localStorage.getItem(
    SETTINGS_KEYS.SHOW_DISTANCE_MEASUREMENTS
  );
  const snappingEnabled = localStorage.getItem(SETTINGS_KEYS.SNAPPING_ENABLED);

  const settings = {
    spellCheckEnabled:
      spellCheckEnabled !== null
        ? spellCheckEnabled === 'true'
        : DEFAULT_SETTINGS.spellCheckEnabled,
    alignmentLinesEnabled:
      alignmentLinesEnabled !== null
        ? alignmentLinesEnabled === 'true'
        : DEFAULT_SETTINGS.alignmentLinesEnabled,
    canvasAlignmentLinesEnabled:
      canvasAlignmentLinesEnabled !== null
        ? canvasAlignmentLinesEnabled === 'true'
        : DEFAULT_SETTINGS.canvasAlignmentLinesEnabled,
    objectAlignmentLinesEnabled:
      objectAlignmentLinesEnabled !== null
        ? objectAlignmentLinesEnabled === 'true'
        : DEFAULT_SETTINGS.objectAlignmentLinesEnabled,
    showDistanceMeasurements:
      showDistanceMeasurements !== null
        ? showDistanceMeasurements === 'true'
        : DEFAULT_SETTINGS.showDistanceMeasurements,
    snappingEnabled:
      snappingEnabled !== null
        ? snappingEnabled === 'true'
        : DEFAULT_SETTINGS.snappingEnabled,
  };

  modifyState('settings', settings);
}

export function saveSettingsToLocalStorage(settings) {
  localStorage.setItem(
    SETTINGS_KEYS.SPELL_CHECK_ENABLED,
    settings.spellCheckEnabled
  );
  localStorage.setItem(
    SETTINGS_KEYS.ALIGNMENT_LINES_ENABLED,
    settings.alignmentLinesEnabled
  );
  localStorage.setItem(
    SETTINGS_KEYS.CANVAS_ALIGNMENT_LINES_ENABLED,
    settings.canvasAlignmentLinesEnabled
  );
  localStorage.setItem(
    SETTINGS_KEYS.OBJECT_ALIGNMENT_LINES_ENABLED,
    settings.objectAlignmentLinesEnabled
  );
  localStorage.setItem(
    SETTINGS_KEYS.SHOW_DISTANCE_MEASUREMENTS,
    settings.showDistanceMeasurements
  );
  localStorage.setItem(
    SETTINGS_KEYS.SNAPPING_ENABLED,
    settings.snappingEnabled
  );
}
